import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import Option from "../../models/Option";
import ScreenGroup from '../../models/ScreenGroup';
import RenderUser from '../RenderUser';


interface ScreenGroupItemProps {
    screenGroup: ScreenGroup;
    defaultOption: Option[];
    openModal: (screenGroup: ScreenGroup) => void;
    visibleCheck?: boolean;
    isChecked?: boolean;
    onChecked?: (screenGroup: ScreenGroup) => void;
};

const ScreenGroupItem: React.FC<ScreenGroupItemProps> = (props: ScreenGroupItemProps) => {

    const isChecked = props.isChecked ?? false;
    const batchActive = props.visibleCheck ?? false;

    const _handleLinkClick = (e: React.MouseEvent) => {
        if (batchActive) e.preventDefault();
    };

    return(
        <div
            className="card mb-3"
            style={batchActive ? { cursor: 'pointer' } : undefined}
            onClick={batchActive ? () => props.onChecked?.(props.screenGroup) : undefined}
        >
            <div className={`card-body screen-item${isChecked ? ' checked' : ''}`}>
                <Link
                    to={`screengroups/${props.screenGroup.id}`}
                    className="screen-item__name"
                    onClick={_handleLinkClick}
                >
                    <i className="iconsminds-monitor"></i>
                    <span className="ml-2">{ props.screenGroup.name }</span>
                </Link>
                <div className="screen-item__actions">
                    <RenderUser item={props.screenGroup} />
                    <button
                        type="button"
                        className="screen-item__edit-btn"
                        onClick={(e) => {
                            if (batchActive) { e.stopPropagation(); return; }
                            props.openModal(props.screenGroup);
                        }}
                    >
                        <i className="iconsminds-pen"></i>
                    </button>
                    <Link
                        to={`screengroups/${props.screenGroup.id}`}
                        className="screen-item__detail-link"
                        onClick={_handleLinkClick}
                    >
                        <FontAwesomeIcon icon={faChevronRight} />
                    </Link>
                </div>
            </div>
        </div>
    );

};

export default React.memo(ScreenGroupItem);
